var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechInvestment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_18_",
    className: "st0",
    d: "M419.6,228.3l9.4-6.3c4.8-3.2,6.1-9.7,2.9-14.6c-3.2-4.8-9.7-6.1-14.6-2.9l-29,19.4 c-0.6,0-1.2-0.1-1.9-0.1c-9.8,0-19.2,1.2-27.8,3.2L429,180c4.8-3.2,6.1-9.7,2.9-14.6c-3.2-4.8-9.7-6.1-14.6-2.9l-78.1,52.1v-16.8 L429,138c2.9-1.9,4.7-5.2,4.7-8.7c0-3.5-1.8-6.8-4.7-8.7l-126-84c-3.5-2.4-8.1-2.4-11.6,0l-94.5,63l-63,42l-94.5,63 c-2.9,1.9-4.7,5.2-4.7,8.7s1.8,6.8,4.7,8.7l126,84c1.8,1.2,3.8,1.8,5.8,1.8c2,0,4.1-0.6,5.8-1.8l78.1-52.1v16.8l-84,56L51.2,246.5 c-4.8-3.2-11.4-1.9-14.6,2.9c-3.2,4.8-1.9,11.3,2.9,14.6l126,84c1.8,1.2,3.8,1.8,5.8,1.8c2,0,4.1-0.6,5.8-1.8L225,316 c-0.6,2.4-1.3,4.9-1.3,7.5v10.1l-52.5,35L51.2,288.5c-4.8-3.2-11.4-1.9-14.6,2.9c-3.2,4.8-1.9,11.3,2.9,14.6l126,84 c1.8,1.2,3.8,1.8,5.8,1.8c2,0,4.1-0.6,5.8-1.8l46.7-31.1v1.4v36.7c0,26.1,35.2,47.2,78.7,47.2c6,0,11.8-0.5,17.4-1.3 c13.9,13.3,38.4,22.2,66.5,22.2c43.5,0,78.7-21.2,78.7-47.2v-36.7v-36.7v-36.7V271C465.2,252,446.4,235.8,419.6,228.3z  M171.3,284.6l-107-71.3l75.5-50.3l45.9,30.6l61.2,40.8l-33.6,22.4L171.3,284.6z M302.5,297.2c1.8,0,3.5,0.2,5.2,0.3v10.2v36.7v5 c-1.8,0.1-3.4,0.3-5.2,0.3c-34.7,0-57.7-15.8-57.7-26.2C244.8,313,267.8,297.2,302.5,297.2z M244.8,355.4 c14.4,9.4,34.8,15.3,57.7,15.3c1.8,0,3.5-0.2,5.2-0.3v10.8v5c-1.8,0.1-3.4,0.3-5.2,0.3c-34.7,0-57.7-15.8-57.7-26.2V355.4z  M302.5,423.2c-34.7,0-57.7-15.8-57.7-26.2v-4.8c14.4,9.4,34.8,15.3,57.7,15.3c1.8,0,3.5-0.2,5.2-0.3v10.8c0,1.7,0.5,3.3,0.8,4.9 C306.5,423,304.6,423.2,302.5,423.2z M318.2,247.8c-1.6,1.7-3.1,3.5-4.4,5.3c-0.3,0.5-0.6,0.9-0.9,1.4c-3.3,5.1-5.2,10.6-5.2,16.4 v5.6c-0.4,0-0.9-0.1-1.3-0.1c-0.4,0-0.9-0.1-1.3-0.1c-0.6-0.1-1.3-0.1-2-0.1c-0.2,0-0.4,0-0.7,0c-3.7,0-7.3,0.2-10.9,0.5 c-2.9,0.3-5.8,0.6-8.6,1.1c-2.3,0.4-4.6,0.8-6.8,1.3v-44.9c0-0.3-0.2-0.5-0.2-0.7c0-0.6-0.2-1.2-0.3-1.8c-0.1-0.4-0.2-0.8-0.4-1.2 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.3-0.2-0.6-0.4-0.9c0,0,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3 c0,0,0-0.1,0-0.1c-0.8-1.2-1.8-2.1-2.9-2.9c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0l-112.8-75.2l44.1-29.4l48.1,32.1l67.3,44.9 V247.8z M281.2,147.9l-59.5-39.6l25.2-16.8L297.2,58l107,71.3l-75.5,50.3L281.2,147.9z M444.2,417.9c0,10.5-23,26.2-57.7,26.2 c-34.7,0-57.7-15.8-57.7-26.2v-4.8c14.4,9.4,34.8,15.3,57.7,15.3c22.9,0,43.3-6,57.7-15.3V417.9z M444.2,381.2 c0,10.5-23,26.2-57.7,26.2c-34.7,0-57.7-15.8-57.7-26.2v-4.8c14.4,9.4,34.8,15.3,57.7,15.3c22.9,0,43.3-6,57.7-15.3V381.2z  M444.2,344.5c0,10.5-23,26.2-57.7,26.2c-34.7,0-57.7-15.8-57.7-26.2v-4.8c14.4,9.4,34.8,15.3,57.7,15.3c22.9,0,43.3-6,57.7-15.3 V344.5z M444.2,307.7c0,10.5-23,26.2-57.7,26.2c-34.7,0-57.7-15.8-57.7-26.2v-4.8c14.4,9.4,34.8,15.3,57.7,15.3 c22.9,0,43.3-6,57.7-15.3V307.7z M386.5,297.2c-34.7,0-57.7-15.8-57.7-26.2c0-10.5,23-26.2,57.7-26.2c34.7,0,57.7,15.8,57.7,26.2 C444.2,281.5,421.2,297.2,386.5,297.2z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechInvestment;